import React from "react";

const QueryStringContext = React.createContext();
export const QueryStringProvider = QueryStringContext.Provider;
export const QueryStringConsumer = QueryStringContext.Consumer;

export default QueryStringContext;
